import type {VariantProps} from "class-variance-authority"
import {cva} from "class-variance-authority"
import type React from "react"

import {cn} from "@/lib/cn"

/**
 * Highlight tags from the style guide: the card/list "highlight bar"
 * (NEW TUTORIAL, CROWDFUNDING NOW) and small status chips.
 */
const badgeVariants = cva(
  "inline-flex items-center justify-center gap-1 font-sans font-bold uppercase leading-none",
  {
    variants: {
      variant: {
        tutorial: "bg-premium text-premium-foreground",
        content: "bg-action text-action-foreground",
        crowdfunding: "bg-tag-crowdfunding text-[#08230a] dark:text-[#eafbe7]",
        action: "bg-action text-action-foreground",
        neutral: "bg-foreground/10 text-foreground",
        price: "bg-action text-action-foreground font-display",
      },
      size: {
        /** Full-width highlight bar on cards (20px tall per style guide). */
        bar: "h-5 w-full text-[11px]",
        chip: "h-5 rounded-mini px-2.5 text-[11px]",
        pill: "h-6 rounded-pill px-3 text-xs",
      },
    },
    defaultVariants: {
      variant: "tutorial",
      size: "chip",
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

/** DIZED highlight tag / status chip. */
export const Badge = ({className, variant, size, ...props}: BadgeProps) => (
  <span className={cn(badgeVariants({variant, size}), className)} {...props} />
)

export {badgeVariants}
